/**
 * Exports {@link RoleList}.
 * @module
 */
module.exports = Backbone.Collection.extend(/** @lends RoleList.prototype */{
	/**
	 * @constructs RoleList
	 * @extends Backbone.Collection
	 * @override
	 */
	initialize: function() {
	},

	/** @override */
	url: function() {
		return App.authRoot + 'systems/' + App.system.id + '/roles'
	}
})
